<div class="topping-modal">
  <div class="pop-up">
    <div class="content-wrap-wrapper">
      <div class="content-wrap">
        <img
          class="wrap-top-icon"
          (click)="closeModal()"
          alt=""
          src="assets/icons/x-icon.svg"
        />
        <div class="content-wrap">
          <div class="content-wrap-wrapper">
            <div class="title">
              <div class="title1">
                {{ "requirements-modal-text-1" | translate }}
              </div>
            </div>
          </div>
          <div class="lorem-ipsum-dolor">
            {{ "requirements-modal-text-2" | translate }}
          </div>
        </div>
      </div>
    </div>
    <div class="requisitos">
      <div class="tag-parent">
        <div class="tag">
          <div class="custom-icons">
            <img
              class="vector-icon"
              alt=""
              src="assets/icons/document-ok-icon.svg"
            />
          </div>
          <div class="text">{{ "requirements-for-solicitude-text-1" | translate }}</div>
        </div>
        <div class="tag">
          <div class="custom-icons">
            <img
              class="vector-icon"
              alt=""
              src="assets/icons/document-text-icon.svg"
            />
          </div>
          <div class="text">{{ "requirements-for-solicitude-text-2" | translate }}</div>
        </div>
        <div class="tag">
          <div class="custom-icons">
            <img
              class="vector-icon"
              alt=""
              src="assets/icons/document-insurance-icon.svg"
            />
          </div>
          <div class="text">{{ "requirements-for-solicitude-text-3" | translate }}</div>
        </div>
        <div class="tag">
          <div class="custom-icons">
            <img
              class="vector-icon3"
              alt=""
              src="assets/icons/refuel-icon.svg"
            />
          </div>
          <div class="text">{{ "requirements-for-solicitude-text-4" | translate }}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="pop-up1">
    <div (click)="closeModal()" class="buttons-2" id="buttons2Container">
      Entendido
    </div>
  </div>
</div>
